module.exports = __webpack_public_path__ + "img/Analyst.png";